export class Printer {

  public static printWhenReady = async (): Promise<void> => {
    if (document.readyState !== "complete") {
      await new Promise<void>((resolve) => window.addEventListener("load", () => resolve(), { once: true }))
    }

    await Promise.all(Printer.getPendingStylesheets())
    await Printer.nextPaint()
    window.print()
  }

  private static getPendingStylesheets = (): Promise<void>[] => {
    const links = Array.from(document.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]'))
    return links
      .filter((link) => !link.sheet)
      .map((link) => new Promise<void>((resolve) => {
        link.addEventListener("load", () => resolve(), { once: true })
        link.addEventListener("error", () => resolve(), { once: true })
      }))
  }

  private static nextPaint = (): Promise<void> =>
    new Promise<void>((resolve) => requestAnimationFrame(() => requestAnimationFrame(() => resolve())))
}
